import axios from 'axios';


// const rootUrl = 'http://localhost:34567/';
const rootUrl = 'https://testapi.royalarabian.com/';
const otpReqUrl = rootUrl + 'user/forgotuserpassword';
const updatePassUrl = rootUrl + 'user/updateuserpassword';

export const reqPasswordOtp = (email) => {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.post(otpReqUrl, { email });
            console.log(data);
            resolve(data);
        } catch (error) {
          console.log(error);
            reject({ status: "error", message: error });
        }
    })
}

export const updateUserPassword = passObj => {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.post(updatePassUrl, passObj);
            //console.log(data);
            resolve(data);
        } catch (error) {

            reject({ status: "error", message: error.message });
        }
    })
}